export enum EventAvailabilityStatus {
  AVAILABLE = "available",
  SOLD_OUT = "sold_out",
  NOT_ON_SALE = "not_on_sale",
  MIXED = "mixed",
}
